var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10548 1.48006C5.71748 0.392062 7.28308 0.392062 7.89428 1.48006L12.3583 9.41606C12.9583 10.4833 12.1879 11.8001 10.9647 11.8001H2.03588C0.811879 11.8001 0.0414787 10.4833 0.641479 9.41606L5.10548 1.48006ZM7.29988 9.40086C7.29988 9.61304 7.21559 9.81652 7.06556 9.96655C6.91553 10.1166 6.71205 10.2009 6.49988 10.2009C6.28771 10.2009 6.08422 10.1166 5.93419 9.96655C5.78416 9.81652 5.69988 9.61304 5.69988 9.40086C5.69988 9.18869 5.78416 8.98521 5.93419 8.83518C6.08422 8.68515 6.28771 8.60086 6.49988 8.60086C6.71205 8.60086 6.91553 8.68515 7.06556 8.83518C7.21559 8.98521 7.29988 9.18869 7.29988 9.40086ZM6.49988 3.00086C6.28771 3.00086 6.08422 3.08515 5.93419 3.23518C5.78416 3.38521 5.69988 3.58869 5.69988 3.80086V6.20086C5.69988 6.41304 5.78416 6.61652 5.93419 6.76655C6.08422 6.91658 6.28771 7.00086 6.49988 7.00086C6.71205 7.00086 6.91553 6.91658 7.06556 6.76655C7.21559 6.61652 7.29988 6.41304 7.29988 6.20086V3.80086C7.29988 3.58869 7.21559 3.38521 7.06556 3.23518C6.91553 3.08515 6.71205 3.00086 6.49988 3.00086Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.086c2ca5a871a249b55db7890f006a6f.svg";
export { ForwardRef as ReactComponent };